import { History } from "history";
import * as React from "react";
import { connect } from "react-redux";
import LoadingSpinner from "src/shared/LoadingSpinner";
import { getSSORedirectUrl } from "../login/selector";
import selectorsToProps from "../utils/selectorsToProps";
import { getSSOCredentials, GetSSOCredentialsActionType } from "./actions";
import "./LoggedOutForm.scss";
import { getSSOApiUrl } from "./selector";

interface LoginProps {
  history: History;
  ssoRedirectUrl: string;
  ssoBaseUrl: string;
  getSSOCredentials: GetSSOCredentialsActionType;
}

interface LoginState {
  authType: string;
}

export class LoginWithSSO extends React.Component<LoginProps, LoginState> {
  constructor(props: LoginProps) {
    super(props);

    this.state = {
      authType: ""
    };
  }

  public componentDidMount() {
    const SSOTokenPromise = this.props.getSSOCredentials();
    Promise.resolve(SSOTokenPromise).then((SSOToken: string) => {
      const SSOClientId = window.atob(SSOToken).split(":")[0];
      setTimeout(() => {
        window.location.href = `${this.props.ssoBaseUrl}/sso-api/auth/authorization?client_id=${SSOClientId}&response_type=code&scope=openid&redirect_uri=${this.props.ssoRedirectUrl}`;
      }, 3000);
    });
  }
  public render() {
    return (
      <div>
        <LoadingSpinner />
      </div>
    );
  }
}

const selectorToProps = selectorsToProps({
  ssoRedirectUrl: getSSORedirectUrl,
  ssoBaseUrl: getSSOApiUrl
});

export default connect(
  selectorToProps,
  {
    getSSOCredentials: getSSOCredentials.action
  }
)(LoginWithSSO);



// WEBPACK FOOTER //
// ./src/login/LoginWithSSO.tsx